import './style.scss';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';

const openSlideGarally = () => {
    const images = document.querySelectorAll('.wp-block-hhb-blocks-garally-blocks .wp-block-hhb-blocks-garally-block');
    const garally = document.getElementById('js-garally-modal');
    const garallyImages = document.getElementById('js-garally-modal-images');

    let swiperGarally;

    if (!images || !garally) return;

    [...images].forEach((value, index) => {
        value.setAttribute('data-num', index);
        value.addEventListener('click', function () {

            const parent = this.parentNode;
            const imageList = parent.cloneNode(true);
            imageList.id = 'js-garally-list';

            const container = document.getElementById('js-garally-container');

            container.insertBefore(imageList, garallyImages);

            swiperGarally = new Swiper('.garally-modal_inner', {
                slidesPerView: 1,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });

            garally.classList.add('open-garally');
            const slideNum = parseInt(this.getAttribute('data-num'), 10);

            swiperGarally.slideTo(slideNum, 0);
        })
    });

    const closeSlideGarally = () => {
        const closeElem = document.getElementsByClassName('js-garally-modal_close');
        const garally = document.getElementById('js-garally-modal');

        if (!closeElem || !garally) return;

        [...closeElem].forEach((value) => {
            value.addEventListener('click', function () {
                const garallyList = document.getElementById('js-garally-list');
                garally.classList.remove('open-garally');
                garallyList.parentNode.removeChild(garallyList);
                swiperGarally.destroy();
            })
        })
    }
    closeSlideGarally();
}
openSlideGarally();